export const SITE = {
  brand: "Noa Grant",
  tagline: "Parent and ADHD Coach",
  promise: "Turn stuck into unstoppable. Coaching for ADHD brains.",
  email: "noagrantcoaching@gmail.com",
  calendly: "https://calendly.com/noagrantcoaching/friend-coaching-session",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_adhd-partnership/artifacts/6paq8ny9_Blue%20White%20Simple%20Website%20Survey%20Google%20Form%20Header.png",
  headshotUrl:
    "https://customer-assets.emergentagent.com/job_adhd-partnership/artifacts/h9sydeu2_headshot%20website%20%281%29.png",
  aboutPhotoUrl:
    "https://customer-assets.emergentagent.com/job_adhd-partnership/artifacts/xqp61rg6_headshot%20website%20%281%29.png",
  addcaLogoUrl:
    "https://customer-assets.emergentagent.com/job_adhd-partnership/artifacts/h7qyrv36_addca_logo_square480x480%2B%281%29.webp",
  serviceImages: {
    adults:
      "https://images.unsplash.com/photo-1748009799611-0fe8744c813c?fm=jpg&q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.1.0",
    parents:
      "https://images.unsplash.com/photo-1758525863085-465f6953ed5c?fm=jpg&q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.1.0",
    group:
      "https://customer-assets.emergentagent.com/job_adhd-partnership/artifacts/d499z586_IMG_8907%20%281%29.JPG",
  },
};
